var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cookies-banner-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "banner",
        class: { displayBanner: _vm.displayBanner },
        attrs: { id: "cookieBanner" },
      },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12", sm: "10" } }, [
              _c("p", [
                _vm._v(
                  "\n          Ce site utilise des cookies pour améliorer votre expérience utilisateur. En continuant à naviguer, vous\n          acceptez notre utilisation des cookies.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    staticClass: "link",
                    attrs: { href: "/politics", target: "_blank" },
                  },
                  [
                    _vm._v(
                      "Conditions générales d'utilisation & Politique de confidentialité"
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "b-col",
              { staticClass: "text-center", attrs: { cols: "12", sm: "2" } },
              [
                _c(
                  "b-col",
                  { staticClass: "mx-auto" },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "12", sm: "6" } }, [
                          _c(
                            "button",
                            {
                              staticClass: "continuer",
                              on: { click: _vm.pressedOk },
                            },
                            [_vm._v("OK")]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }